import { STATUS } from '../../constants/status.constants';

export const postsInitState = {
  posts: null,
  status: STATUS.idle,
};
